export class Combo {
	id: number;
	nome: string;
}